<template>
  <div
    v-if="totalPriceAfterPromotions"
    class="background-color-white border-top d-flex full-width justify-center fixed px-3"
  >
    <v-btn
      color="success"
      class="my-5 mx-5"
      height="60"
      @click.stop="checkout"
      block
      x-large
    >
      <span class="font-weight-semibold text-capitalize e2e-checkout-button"
        >check out</span
      >
      <span
        class="checkout-button-price-box font-weight-semibold pa-3 position-absolute right e2e-checkout-total"
        >{{ formatCurrency(totalPriceAfterPromotions) }}</span
      >
    </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatCurrency } from "@/util.js";

export default {
  name: "CheckOutButton",
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    checkout() {
      if (this.metMinimumOrderAmount()) {
        this.$router.push({ name: "checkout" });
        this.$vuetify.breakpoint.smAndUp && this.$store.commit("cart/TOGGLE");
      } else {
        this.$store.commit("orders/OPEN_MINIMUM_ORDER_AMOUNT_DIALOG");
      }
    },
    formatCurrency,
    metMinimumOrderAmount() {
      return this.totalPriceAfterPromotions >= this.storeInfo.min_order_amount;
    },
  },
  props: { totalPriceAfterPromotions: Number },
};
</script>

<style scoped>
.checkout-button-price-box {
  background-color: #3a9127;
  border-radius: 6px;
}

.fixed {
  position: fixed;
  left: 0;
  bottom: 0;
}

.right {
  right: 0;
}
</style>
